module.exports = __webpack_public_path__ + "static/media/sustainable-farm.623ce814.jpg";